






































import { Component, Vue } from 'vue-property-decorator';
import AppMenuService from '@/services/appMenu.service';
import SidebarMenuItem from '@/components/base-layout/menu/SidebarMenuItem.vue';

@Component({
  components: { SidebarMenuItem },
})
export default class SidebarMenu extends Vue {
  private appService = AppMenuService;

  get items() {
    return this.appService.getMenuItems();
  }
}
